/**
 * Combined "from – to €" rent range, rendered as two number inputs sharing one
 * bordered container. Each caller parses the raw string itself (the offers and
 * flats tables differ in how they sanitise the value).
 */
interface RentRangeInputProps {
  minValue: number | string | undefined
  maxValue: number | string | undefined
  onMinChange: (raw: string) => void
  onMaxChange: (raw: string) => void
  fromPlaceholder: string
  toPlaceholder: string
}

export function RentRangeInput({
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  fromPlaceholder,
  toPlaceholder
}: RentRangeInputProps) {
  return (
    <div className="flex h-10 items-center rounded-2xl border border-ink/[0.16] bg-white px-3 transition-colors focus-within:border-primary">
      <input
        type="number"
        min={0}
        inputMode="numeric"
        placeholder={fromPlaceholder}
        value={minValue ?? ''}
        onChange={(e) => onMinChange(e.target.value)}
        className="h-full w-full min-w-0 border-0 bg-transparent text-sm text-ink outline-none placeholder:text-muted-foreground"
      />
      <span className="px-1.5 text-muted-foreground">–</span>
      <input
        type="number"
        min={0}
        inputMode="numeric"
        placeholder={toPlaceholder}
        value={maxValue ?? ''}
        onChange={(e) => onMaxChange(e.target.value)}
        className="h-full w-full min-w-0 border-0 bg-transparent text-sm text-ink outline-none placeholder:text-muted-foreground"
      />
      <span className="pl-1 text-sm text-muted-foreground">€</span>
    </div>
  )
}
